import {
  ENUM_COMPONENTSHAREDBENTOCARD_ICONKEY,
  ENUM_COMPONENTSHAREDBENTOCARD_TYPE,
  Maybe,
} from './globalTypes'

import {
  ContentPopFragment,
  isContentPopFragment,
} from './ContentPopFragment'

import {
  ProductPopFragment,
  isProductPopFragment,
} from './ProductPopFragment'

import { GridType, isGridType } from './GridType'

import bentoCardFragmentRawString from '../../fragments/BentoCardFragment.graphql'

export const bentoCardFragmentString = bentoCardFragmentRawString

export type BentoCardFragment = {
  __typename: 'ComponentSharedBentoCard'
  id: string
  title: string
  iconKey: ENUM_COMPONENTSHAREDBENTOCARD_ICONKEY
  type: ENUM_COMPONENTSHAREDBENTOCARD_TYPE
  description: Maybe<string>
  detailsContent: Maybe<ContentPopFragment>
  detailsProduct: Maybe<ProductPopFragment>
  gridArea: Maybe<GridType>
}

export const isBentoCardFragment = (
  fragment: any,
): fragment is BentoCardFragment =>
  fragment &&
  fragment.__typename === 'ComponentSharedBentoCard' &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  (fragment.iconKey === 'catalog_card_2' ||
    fragment.iconKey === 'photo_drop' ||
    fragment.iconKey === 'build_your_own_card' ||
    fragment.iconKey === 'paper_plane_2' ||
    fragment.iconKey === 'personal_touch' ||
    fragment.iconKey === 'candy' ||
    fragment.iconKey === 'gift_2' ||
    fragment.iconKey === 'gift_card' ||
    fragment.iconKey === 'hand_written' ||
    fragment.iconKey === 'contact_card' ||
    fragment.iconKey === 'multi_card_campaign' ||
    fragment.iconKey === 'virtual_assistance' ||
    fragment.iconKey === 'custom_brand') &&
  (fragment.type === 'content' || fragment.type === 'product') &&
  (fragment.description === null || typeof fragment.description === 'string') &&
  (fragment.detailsContent === null ||
    (isContentPopFragment(fragment.detailsContent) as boolean)) &&
  (fragment.detailsProduct === null ||
    (isProductPopFragment(fragment.detailsProduct) as boolean)) &&
  (fragment.gridArea === null || (isGridType(fragment.gridArea) as boolean))
